// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1wSUO","sendOtp":"AuthorizeToLogin_sendOtp__3F9f1"};